import { useContext, createContext, useState, useEffect } from "react";
import { getRcds } from "../../axios_with_token";
import { useLoginContext } from "./LoginContext";

const ordersContext = createContext();
export function useOrdersContext(){
    return useContext(ordersContext);
}

export default function OrdersContextProvider({children}){
    const { userInfo: wwAppUserInfo } = useLoginContext();
    const [orders, setOrders] = useState([]);
    const [page, setPages] = useState(0);
    const [pageLength, setPageLength] = useState(10);

    // [] how about another user add / del / update the orders
    const addOrder = ()=>{

    };

    useEffect(_=>{
        console.log('fetching orders');
        getRcds("wwAppOrders", {
           filters: {
            client: `^${wwAppUserInfo.__id}$`,
            // paging
          }
        }).then(res=>{
            // console.log('res:', res);
            setOrders(res.rcds);
        });
        
    }, [page, pageLength]);

    return <ordersContext.Provider
        value={{
            addOrder,
            orders
        }}
    
    >{children}</ordersContext.Provider>;
}